const s = {
  name: "Ratio2x5",
  dimensions: { width: 16, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16 40" style="enable-background:new 0 0 16 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,34v-4H4v6h6v-2H6z"/>
		<path class="st0" d="M6,6h4v4h2V4H6V6z"/>
		<path class="st0" d="M16,0v40H0V0H16z M14,2H2v36h12V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ratio2x5
};
